/**
 * @file        dcp-client-bundle-src.js
 *              Top-level file which gets webpacked into the bundle consumed by dcp-client 2.5
 * @author      Wes Garland, wes@kingsds.network
 * @date        July 2019
 */
'use strict';
{
  let thisScript = typeof document !== 'undefined' ? (typeof document.currentScript !== 'undefined' && document.currentScript) || document.getElementById('_dcp_client_bundle') : {}
  let realModuleDeclare

  if (typeof module === 'undefined' || typeof module.declare === 'undefined') {
    realModuleDeclare = (typeof module === 'object') ? module.declare : null
    if (typeof module !== 'object') {
      module = { exports: {} }  // eslint-disable-line
    }
    module.declare = function moduleUnWrapper (deps, factory) {
      factory(null, module.exports, module)
      return module.exports
    }
  }

  let _debugging = () => false

  /* These modules are official API and must be part of DCP Client */
  let officialApi = {
    protocol:   require('../protocol'),
    compute:    require('./compute').compute,
    worker:     require('./worker'),
    wallet:     require('./wallet'),
    identity:   require('./identity'),
    jnu:        require('./jnu'),
    types:      require('../types'),
  };

  /* Some of these modules are API-track. Some of them need to be published to be
   * available for top-level resolution by DCP internals. Those (mostly) should have
   * been written using relative module paths.....
   */
  let modules = Object.assign({
    'dcp-build': __DCP_CLIENT__,
    'fs-basic': require('../common/fs-basic'),
    'os-basic': require('../common/os-basic'),
    'dcp-xhr': require('../common/dcp-xhr'),
    'dcp-env': require('../common/dcp-env'),
    'dcp-url': require('../common/dcp-url'),
    'cli': require('../common/cli'),
    'dcp-timers': require('../common/dcp-timers'),
    'resource-dir': require('../utils/resource-dir'),
    'constants': require('../common/constants'),
    'dcp-assert': require('../common/dcp-assert'),
    'dcp-events': require('../common/dcp-events'),
    'utils': require('../utils'),
    'debugging': require('../debugging'),
    'publish': require('../common/dcp-publish'),
    'compute-groups': require('./compute-groups'),
    'dom-tk': require('./dom-tk'),
    'eth': require('./wallet/eth'),
    'serialize': require('../utils/serialize'),
    'kvin': require('kvin'),
    'job': require('./job'),
    'range-object': require('./range-object'),
    'stats-ranges': require('./stats-ranges'),
    'job-values': require('./job-values'),
    'signal-handler': require('../node-libs/signal-handler'),
    'standard-objects': {},
    'bignumber.js': require('dcp/types').BigNumber,
  }, officialApi);

  /* Export the JS Standard Classes (etc) from the global object of the bundle evaluation context,
   * in case we have code somewhere that needs to use these for instanceof checks.
   */
  ;[ Object, Function, Boolean, Symbol,
    Error, EvalError, RangeError, ReferenceError, SyntaxError, TypeError, URIError,
    Number, Math, Date,
    String, RegExp,
    Array, Int8Array, Uint8Array, Uint8ClampedArray, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array,
    Map, Set, WeakMap, WeakSet,
    ArrayBuffer, DataView, JSON,
    Promise,
    Reflect, Proxy, WebAssembly, __webpack_require__
  ].forEach(function (obj) {
    if (obj.name && (typeof obj === 'function' || typeof obj === 'object'))
      modules['standard-objects'][obj.name] = obj
  });
  modules['standard-objects']['Intl'] = typeof Intl === 'object' ? Intl : {};

  /* Export the constructors used by object literals and boxing objects. Usually these are the same as
   * the standard objects, but not always -- evaluation environments like node vm contexts can have
   * different standard objects supplied via the sandboxing object than the engine uses internally.
   */
  modules['engine-constructors'] = {
    Object:   ({}).constructor,
    Array:    ([]).constructor,
    Number:   (0).constructor,
    String:   ('').constructor,
    Boolean:  (false).constructor,
    Function: (()=>1).constructor,
  };

  if (typeof BigInt !== 'undefined')
  {
    modules['standard-objects']['BigInt'] === BigInt;
    modules['engine-constructors'].BigInt  = (0n).constructor;
  }
  if (typeof BigInt64Array !== 'undefined')
    modules['standard-objects']['BigInt64Array'] === BigInt64Array;
  if (typeof BigInt64Array !== 'undefined')
    modules['standard-objects']['BigUint64Array'] === BigUint64Array;

  module.declare([], function(require, exports, module) {
    Object.assign(exports, modules)
    exports['dcp-config'] = dcpConfig
    exports['dcp-default-config'] = __DCP_DEFAULT_CONFIG__;
  })
  if (realModuleDeclare)
    module.declare = realModuleDeclare

  bundleExports = thisScript.exports = exports; /* must be last expression evaluated! */
}
